// Loan health dashboard — shared display vocabulary for the scorecard,
// the needs-attention feed, and the vitals tints. Status tokens only
// (Convention: same condition = same color everywhere; gold is brand,
// never state).

import type {
  DisciplineSeverity,
  HealthDiscipline,
} from "@/api/portfolioAdmin/loanHealthApi";

export const DISCIPLINE_LABEL: Record<HealthDiscipline, string> = {
  payments: "Payments",
  insurance: "Insurance",
  ucc: "UCC",
  covenants: "Covenants",
  reporting: "Reporting",
  vendors: "Vendors",
  qa: "QA",
  defaults: "Defaults",
};

export function disciplineLabel(discipline: string): string {
  return DISCIPLINE_LABEL[discipline as HealthDiscipline] ?? "Other";
}

/** Status dot for a scorecard light / feed row. */
export const SEVERITY_DOT_CLASS: Record<DisciplineSeverity, string> = {
  ok: "bg-status-success",
  warning: "bg-status-warning",
  error: "bg-status-error",
  unavailable: "bg-gray-mid",
};

export const SEVERITY_TEXT_CLASS: Record<DisciplineSeverity, string> = {
  ok: "text-status-success",
  warning: "text-status-warning",
  error: "text-status-error",
  unavailable: "text-gray-mid",
};
